import React from "react";
import Typography from "@material-ui/core/Typography";
import {ListItem, makeStyles} from "@material-ui/core";
import {useI18N} from "../../../common/common";
import Grid from "@material-ui/core/Grid";
import {StreamlineIcon} from "@hapinest/theme";
import AlertCircle from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/interface-essential/alerts/alert-circle.svg";

const useStyles = makeStyles((theme) => ({
    listItem: {
        paddingLeft: 0,
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2),
        color: "#000",
        whiteSpace: "nowrap"
    },
    grid: {
        display: "flex",
        alignContent: "center"
    },
    warningInfo: {
        fontWeight: 600,
        color: theme.palette.grey[400],
        marginLeft: theme.spacing(2),
        whiteSpace: "initial"
    },
    warningInfoNoBold: {
        fontWeight: 100,
        color: theme.palette.grey[400]
    },
    alertIcon: {
        color: theme.palette.error.main,
        fontSize: theme.spacing(2.75)
    }
}));

const PriceWarning = () => {

    const classes = useStyles();
    const {i18n} = useI18N();

    return (
        <ListItem
            component="nav"
            className={classes.listItem}
        >
            <Grid
                item
                md={12}
                xs={12}
                sm={12}
                className={classes.grid}
            >
                <StreamlineIcon
                    className={classes.alertIcon}
                >
                    <AlertCircle/>
                </StreamlineIcon>

                <Typography
                    variant="body2"
                    color="textSecondary"
                    className={classes.warningInfo}
                >
                    {i18n("view.marketplace.create_offer.processing_fee")}&nbsp;
                    <span className={classes.warningInfoNoBold}>
                        {i18n("view.marketplace.create_offer.offer_due")}
                    </span>
                </Typography>
            </Grid>
        </ListItem>
    );
};

PriceWarning.propTypes = {};

export default PriceWarning;
